import { QueryKey, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import { useHostingSitesV2 } from '@newfold/huapi-js';
import {
  HostingSitesV2Params,
  HostingSitesV2200,
  HostingSitesV2200ItemsItem,
} from '@newfold/huapi-js/src/index.schemas';

import { removeDeletedSites } from '~/utils/site/helpers';

type TData = AxiosResponse<HostingSitesV2200, any>;
type TError = AxiosError<unknown, any>;
type QueryOptionsTypes =
  | {
      query?:
        | Partial<UseQueryOptions<TData, TError, TData, QueryKey>>
        | undefined;
      axios?: AxiosRequestConfig<any> | undefined;
    }
  | undefined;

const useFilteredHostingSites = (
  hostingId: string,
  params?: HostingSitesV2Params | object,
  options?: QueryOptionsTypes,
) => {
  const { data, isPending, isError, isSuccess, ...rest } = useHostingSitesV2(
    hostingId,
    params ?? ({} as HostingSitesV2Params),
    options,
  );

  if (isPending || isError) {
    return { ...rest, data, isPending, isError, isSuccess };
  }

  const sites = data?.data?.items;
  const filteredSites = removeDeletedSites(sites) as
    | HostingSitesV2200ItemsItem[]
    | undefined;

  const sitesWithTypeWPForced = filteredSites?.map((site) => ({
    ...site,
    name:
      site.name === null && site.migration_id ? 'Migrating Site' : site.name, // Use site.name if not null, otherwise use default value
    type: site.type || 'wordpress', // TODO: Once the backend returns the type this default WordPress type can be removed
  }));

  return {
    ...rest,
    isPending,
    isError,
    isSuccess,
    data: {
      ...data,
      data: { ...data?.data, items: sitesWithTypeWPForced },
    },
  };
};

export default useFilteredHostingSites;
